// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3qpwL","load3":"Spinner_load3__32wqx","loaderWhite":"Spinner_loaderWhite__F9n7U"};